import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { DialogContent, DialogActions, Button, ThemeProvider, Grid, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import vadoTheme from '../main/VadoThemeMui5';
import AddressInput from '../common/addressinput';
import EInvoiceInput from '../common/einvoiceinput';
import Address from '../domain/address';
import ElectronicInvoiceInfo from '../domain/electronicinvoiceinfo';
import Add from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

export default function BillingEditDialog({ dialogOpen, billingAddress, einvoiceAddress, cancel, save }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();
    const [localBillingAddress, setLocalBillingAddress] = useState(billingAddress || null);
    const [localEinvoiceAddress, setLocalEinvoiceAddress] = useState(einvoiceAddress || null);

    const onSave = () => {
        save(localBillingAddress, localEinvoiceAddress);
    };

    const onCancel = () => {
        cancel();
    };

    const addBillingAddress = () => {
        setLocalBillingAddress(new Address());
    };

    const addEinvoiceAddress = () => {
        setLocalEinvoiceAddress(new ElectronicInvoiceInfo());
    };

    const removeBillingAddress = () => {
        setLocalBillingAddress(null);
    };

    const removeEinvoiceAddress = () => {
        setLocalEinvoiceAddress(null);
    };

    return (
        <ThemeProvider theme={vadoTheme}>
            <Dialog
                aria-labelledby="billing-edit-dialog"
                open={dialogOpen}
                fullWidth={true}
                maxWidth={'md'}
                fullScreen={fullScreen}>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <strong>{t('general.invoicingAddress')}</strong>
                            {localBillingAddress && (
                                <IconButton size="small" color="secondary" onClick={removeBillingAddress}>
                                    <DeleteIcon />
                                </IconButton>
                            )}
                        </Grid>
                        {localBillingAddress ? (
                            <Grid item xs={12}>
                                <AddressInput
                                    idBase={'billingeditdialog-billing'}
                                    address={localBillingAddress}
                                    addressChanged={setLocalBillingAddress}
                                />
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    id="btn-add-billing-address"
                                    name="btn-add-billing-address"
                                    startIcon={<Add />}
                                    onClick={addBillingAddress}>
                                    {t('general.invoicingAddress')}
                                </Button>
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <strong>{t('general.eInvoiceAddress')}</strong>
                            {localEinvoiceAddress && (
                                <IconButton size="small" color="secondary" onClick={removeEinvoiceAddress}>
                                    <DeleteIcon />
                                </IconButton>
                            )}
                        </Grid>
                        {localEinvoiceAddress ? (
                            <Grid item xs={12}>
                                <EInvoiceInput
                                    einvoiceinfo={localEinvoiceAddress}
                                    einvoiceinfoChanged={setLocalEinvoiceAddress}
                                    idBase={'billingeditdialog-einvoice'}
                                />
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    id="btn-add-email-invoice-address"
                                    name="btn-add-email-invoice-address"
                                    startIcon={<Add />}
                                    onClick={addEinvoiceAddress}>
                                    {t('general.eInvoiceAddress')}
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="inherit" name="address-edit-cancel" onClick={onCancel}>
                        {t('buttons.cancel')}
                    </Button>
                    <Button variant="contained" color="primary" name="address-edit-save" onClick={onSave}>
                        {t('buttons.save')}
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}
